// src/services/auth.service.js
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase";

class AuthService {
  // Login with Firebase
  static async login(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return { firebaseUser: userCredential.user };
    } catch (error) {
      throw error;
    }
  }

  // Create Firebase account
  static async signup({ email, password, firstName, lastName, phone }) {
    let firebaseUser;
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      firebaseUser = userCredential.user;
      
      // Profile data is managed on backend via Firebase triggers
      return { firebaseUser };
    } catch (error) {
      try {
        if (firebaseUser) await firebaseUser.delete();
      } catch {
        // no-op
      }
      throw error;
    }
  }

  /**
   * Get current user's Firebase ID token
   * Used by api.service.js to make authenticated API calls
   */
  static async getAccessToken() {
    try {
      const user = auth.currentUser;
      if (!user) return null;

      // Force refresh to ensure token is fresh
      return await user.getIdToken(true);
    } catch (_) {
      return null;
    }
  }

  static async logout() {
    return signOut(auth);
  }
}

export default AuthService;